









































































































































































































































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import EstimateItemViewModel from "../presenters/estimate-item-view-model";
import EstimateRow from "./EstimateRow.vue";
import SelectOption from "../../../common/ui/presenters/select-option";
import { EnvironmentMixin } from "@/helpers/environment-mixin";
import Decimal from "decimal.js";
import { ESTIMATE_ITEM_LEVEL } from "@/preferences";

@Component({
  computed: {
    ESTIMATE_ITEM_LEVEL() {
      return ESTIMATE_ITEM_LEVEL;
    }
  },
  components: {
    EstimateRow
  }
})
export default class EstimateItem extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) item!: EstimateItemViewModel;
  @Prop({ required: true }) unitOptions!: SelectOption[];
  @Prop({ required: true }) expenseCategoryOptions!: SelectOption[];
  @Prop({ required: true }) level!: number;
  @Prop({ required: true }) isShowNoteColumn!: boolean;
  @Prop({ required: true }) styleGridColumn!: string;
  @Prop({ required: true }) estimateRowSelected!: Set<string>;
  @Prop({ required: true }) profitRateOfEstimate!: number;
  @Prop({ required: false }) isHideVendorColumn?: boolean;
  @Prop({ required: true }) isDiscountRow!: boolean;
  @Prop({ required: true }) isFirstItemInLayer!: boolean;
  @Prop({ required: true }) index!: number;

  isCheckedInput: boolean = false;

  get profitRatePercent(): number {
    if (!this.item.totalPrice || this.item.totalPrice === 0) {
      return 0;
    }
    return Number(
      new Decimal(this.item.totalPrice)
        .minus(this.item.loss)
        .div(this.item.totalPrice)
        .mul(100)
        .toFixed(1)
    );
  }

  profitAmount(item: EstimateItemViewModel): number {
    if (!this.item) {
      return 0;
    }
    return item.totalPrice - item.loss;
  }

  calculate() {
    this.$emit("change");
  }

  emitPreview(e: Event) {
    const target = (e.target as any) || null;
    if (target && typeof target.closest === "function") {
      const wrap = target.closest('[data-preview-field="expenseCategory"]');
      if (wrap) {
        const sel =
          wrap.tagName === "SELECT"
            ? (wrap as HTMLSelectElement)
            : (wrap.querySelector("select") as HTMLSelectElement | null);
        if (sel) {
          const v = sel.value;
          const opt = this.expenseCategoryOptions.find(
            o => String(o.value) === String(v)
          );
          this.$emit("preview", {
            value: opt != null ? String(opt.text) : ""
          });
          return;
        }
      }
    }
    let el:
      | HTMLInputElement
      | HTMLSelectElement
      | HTMLTextAreaElement
      | null = null;
    if (target && typeof target.closest === "function") {
      el = target.closest("input,select,textarea");
    }
    let value = "";
    if (el) {
      const anyEl = el as any;
      if (anyEl.type === "checkbox") {
        return;
      }
      if (anyEl.value != null) {
        value = String(anyEl.value);
      }
    }
    this.$emit("preview", { value });
  }

  isEstimateRowSelected(item: EstimateItemViewModel): boolean {
    if (item.items.length > 0) {
      return item.items.some(subItem => this.isEstimateRowSelected(subItem));
    }
    return this.estimateRowSelected.has(item.id.toString());
  }

  get isChecked(): boolean {
    return this.isEstimateRowSelected(this.item);
  }

  @Watch("estimateRowSelected")
  changeEstimateRowSelected() {
    this.isCheckedInput = this.isChecked;
  }

  addLowestItemToSet(item: EstimateItemViewModel) {
    if (item.items.length > 0) {
      item.items.forEach(it => this.addLowestItemToSet(it));
    } else {
      this.estimateRowSelected.add(item.id.toString());
    }
  }

  removeLowestItemFromSet(item: EstimateItemViewModel) {
    if (item.items.length > 0) {
      item.items.forEach(it => this.removeLowestItemFromSet(it));
    } else {
      this.estimateRowSelected.delete(item.id.toString());
    }
  }

  handleEstimateRowChecked(isChecked: boolean) {
    isChecked
      ? this.addLowestItemToSet(this.item)
      : this.removeLowestItemFromSet(this.item);
    this.$emit("afterChecked");
  }

  get isWarning(): boolean {
    return (
      this.profitRatePercent !== 0 &&
      this.profitRatePercent < this.profitRateOfEstimate
    );
  }

  isNegative(value: number): boolean {
    return value < 0;
  }

  get disableUpLevel(): boolean {
    if (this.isRouterNameActual) {
      return true;
    }
    return this.level === ESTIMATE_ITEM_LEVEL.PARENT;
  }

  get disableDownLevel(): boolean {
    if (this.isRouterNameActual) return true;

    const isGrandChild: boolean =
      this.level === ESTIMATE_ITEM_LEVEL.GRAND_CHILD;
    const isChildHasGrandChild: boolean =
      this.level === ESTIMATE_ITEM_LEVEL.CHILD && this.item.items.length > 0;
    const isParentHasGrandChild: boolean =
      this.level === ESTIMATE_ITEM_LEVEL.PARENT &&
      this.item.items.length > 0 &&
      this.item.items.some(child => child.items.length > 0);
    return (
      isGrandChild ||
      isChildHasGrandChild ||
      isParentHasGrandChild ||
      this.isFirstItemInLayer
    );
  }

  get isEditableEstimate(): boolean {
    if (!this.isRouterNameActual) {
      return false;
    }

    return !this.item.isEditable;
  }

  handleCreate(item: EstimateItemViewModel) {
    this.$emit("create", item.id);
  }

  handleRemove(item: EstimateItemViewModel) {
    if (this.isEditableEstimate) return;
    this.$emit("remove", item.id);
  }

  get isRouterNameActual(): boolean {
    return this.$route.name === "order-estimate-actual";
  }

  get isDisableBtnLeft(): boolean {
    if (!this.isRouterNameActual) return false;

    return (
      this.level == ESTIMATE_ITEM_LEVEL.CHILD ||
      this.level == ESTIMATE_ITEM_LEVEL.GRAND_CHILD
    );
  }
}
